var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgPix = _a => {
  var _b, _c, _d, _e;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    d: "M15.4127 17.3434L15.4126 17.3433L12.1389 14.0697L8.85321 17.3554L8.85306 17.3556C8.32045 17.8878 7.65839 18.2469 6.93854 18.4032L10.0968 21.5615C10.0968 21.5615 10.0968 21.5615 10.0968 21.5615C11.1482 22.6128 12.8528 22.6128 13.9042 21.5615C13.9042 21.5615 13.9042 21.5615 13.9042 21.5615L17.1243 18.3414C16.4831 18.1654 15.8948 17.8254 15.4127 17.3434Z",
    stroke: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    strokeWidth: 1.3
  }), React.createElement("path", {
    d: "M8.85146 6.64479L8.85158 6.64491L12.1371 9.931L15.4109 6.6569L15.4111 6.65676C15.8932 6.17484 16.4815 5.83487 17.1227 5.65884L13.9026 2.43877C12.8512 1.38737 11.1466 1.38737 10.0952 2.43877L6.93706 5.59692C7.65691 5.75325 8.31895 6.11246 8.85146 6.64479ZM12.1105 9.9576L12.1106 9.95753L12.1105 9.9576Z",
    stroke: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor',
    strokeWidth: 1.3
  }), React.createElement("path", {
    d: "M21.5615 10.0973L21.5615 10.0973L19.2554 7.79119H18.157C17.734 7.79119 17.3166 7.96414 17.018 8.26298L17.0178 8.26315L13.7181 11.5629C13.5306 11.7505 13.3177 11.8977 13.0904 12.0045C13.3199 12.1092 13.5333 12.2542 13.7183 12.4394L17.0178 15.7385L17.0181 15.7388C17.3167 16.0377 17.734 16.2106 18.157 16.2106H19.2554L21.5614 13.9047C21.5614 13.9047 21.5615 13.9047 21.5615 13.9047C22.6129 12.8531 22.6128 11.1485 21.5615 10.0973ZM10.559 12.4386C10.7439 12.2539 10.9572 12.1092 11.1866 12.0045C10.9595 11.8978 10.7467 11.7508 10.5593 11.5635L10.5591 11.5633L7.24695 8.25115L7.24684 8.25104C6.94805 7.95211 6.53078 7.77919 6.10778 7.77919H4.7566L2.43854 10.0973L2.43853 10.0973C1.38718 11.1485 1.38713 12.8531 2.43854 13.9047C2.43855 13.9047 2.43856 13.9047 2.43856 13.9047L4.7565 16.2226H6.10778C6.53078 16.2226 6.94805 16.0497 7.24684 15.7508L7.24695 15.7507L10.5588 12.4388L10.559 12.4386Z",
    stroke: (_e = props.color) !== null && _e !== void 0 ? _e : 'currentColor',
    strokeWidth: 1.3
  }));
};
export default SvgPix;